<template>
  <v-flex xs12 ma-4>
    <v-form v-model="valid" lazy-validation ref="eventLanguageForm">
      <v-card class="elevation-6" style="border-radius: 1em; minWidth: 700px">
        <v-container class="scrollablePage">
          <v-layout column pb-4>
            <v-flex ma-1>
              <v-layout>
                <v-icon color="primary" style="font-size: 40px;">border_color</v-icon>
                <h1 :style="`color: ${$vuetify.theme.primary}`" class="mt-3 ml-4">{{EventName}}</h1>
              </v-layout>
            </v-flex>
            <v-flex ma-1>
              <v-layout>
                <v-flex ma-1>
                  <v-layout row ma-1>
                    <v-icon color="secondary" style="font-size: 40px;">chat_bubble_outline</v-icon>
                    <h2 :style="`color: ${$vuetify.theme.secondary}`" class="ml-4">{{LanguageSpec}}</h2>
                  </v-layout>
                  <v-card ma-1 style="border-radius: 1em;">
                    <v-list style="max-height: 200px" class="scroll-y">
                      <template v-for="(item, index) in Languages">
                        <v-list-tile :key="item.LanguageId" ripple @click="toggle(index)">
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.LocalName }}</v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon
                              v-if="Selected != index"
                              color="grey lighten-1"
                            >keyboard_arrow_right</v-icon>
                            <v-icon v-else color="grey darken-2">arrow_forward_ios</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider v-if="index + 1 < Languages.length" :key="index"></v-divider>
                      </template>
                    </v-list>
                  </v-card>
                  <v-tooltip bottom>
                    <v-btn
                      round
                      slot="activator"
                      color="secondary"
                      class="v-btn-5 dialogButton text-capitalize"
                      disabled
                    >{{$translate('ADD_LANGUAGE_PLUS')}}</v-btn>
                    <span>{{$translate('ADD_LANGUAGE')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex ma-1>
                  <v-layout column ma-1>
                    <h4>{{$translate('LANGUAGE')}}</h4>
                    <v-text-field
                      v-model="Language"
                      rows="1"
                      auto-grow
                      :label="Language"
                      required
                      solo
                      readonly
                    />
                    <h4>Event translation name</h4>
                    <v-text-field
                      v-model="EventTranslationName"
                      rows="1"
                      solo
                      @change="formChanged"
                    />
                    <h4>Event short description</h4>
                    <v-text-field
                      v-model="EventSubtitle"
                      rows="1"
                      solo
                      @change="formChanged"
                    />
                    <h4>{{$translate('ARRIVAL_TEXT_MSG')}}</h4>
                    <v-textarea
                      v-model="ArrivalTextMessage"
                      counter
                      maxlength="255"
                      no-resize
                      full-width
                      rows="4"
                      outline
                      @change="formChanged"
                      tabindex="2"
                    ></v-textarea>
                    <!-- <event-audio-loader
                      :properties="audioProp1"
                      v-on:selectAudio1Element="setAudioElement"
                    ></event-audio-loader> -->
                    <h4>Arrival audio message</h4>
                    <v-text-field
                      v-model="AudioArrivalUrl"
                      rows="1"
                      solo
                      @change="formChanged"
                    />
                    <h4>Event question</h4>
                    <v-textarea
                      v-model="Question"
                      counter
                      maxlength="255"
                      no-resize
                      full-width
                      rows="4"
                      outline
                      tabindex="2"
                      @change="formChanged"
                    ></v-textarea>
                    <h4>Event answer A</h4>
                    <v-text-field
                      v-model="AnswerA"
                      rows="1"
                      solo
                      @change="formChanged"
                    />
                    <h4>Header - Personalised confirmation-mail header</h4>
                    <v-textarea
                      v-model="ConfirmationMailHeader"
                      full-width
                      rows="4"
                      outline
                      tabindex="2"
                      @change="formChanged"
                    ></v-textarea>
                  </v-layout>
                </v-flex>
                <v-flex ma-2>
                  <v-layout class="outliningRightSide" column reverse>
                    <div>
                      <h4>{{$translate('DESCRIPTION')}}</h4>
                      <v-textarea
                        v-model="Description"
                        counter
                        maxlength="4096"
                        no-resize
                        v-on:keyup="keymonitor"
                        full-width
                        rows="4"
                        outline
                        :rules="[validateDescriptionField]"
                        @change="formChanged"
                        tabindex="1"
                      ></v-textarea>
                      <h4>{{$translate('DEPARTURE_TEXT_MSG')}}</h4>
                      <v-textarea
                        v-model="DepartureTextMessage"
                        counter
                        maxlength="255"
                        no-resize
                        full-width
                        rows="4"
                        outline
                        @change="formChanged"
                        tabindex="3"
                      ></v-textarea>
                      <!-- <event-audio-loader
                        :properties="audioProp2"
                        v-on:selectAudio2Element="setAudioElement"
                      ></event-audio-loader> -->
                      <h4>Departure audio message</h4>
                      <v-text-field
                      v-model="AudioDepartureUrl"
                      rows="1"
                      solo
                      @change="formChanged"
                    />
                     <h4>Event correct answer</h4>
                    <v-select
                     :items="answerOptions"
                     v-model="CorrectAnswer"
                     full-width
                     outline
                     @change="formChanged"
                    ></v-select>
                    <h4 class="eventAnswerBOutlining">Event answer B</h4>
                    <v-text-field
                      v-model="AnswerB"
                      rows="1"
                      solo
                      @change="formChanged"
                    />
                    <h4>Footer - Personalised confirmation-mail footer</h4>
                    <v-textarea
                      v-model="ConfirmationMailFooter"
                      full-width
                      outline
                      rows="4"
                      tabindex="2"
                      @change="formChanged"
                    ></v-textarea>
                    </div>
                  </v-layout>
                </v-flex>

              </v-layout>
            </v-flex>
            <v-flex ma-1>
              <v-layout>
                <v-spacer/>
                <v-tooltip bottom>
                  <v-btn
                    round
                    slot="activator"
                    color="secondary"
                    class="v-btn-5 dialogButton text-capitalize"
                    @click="goBack"
                  >{{$translate('BACK')}}</v-btn>
                  <span>{{$translate('PREV_SCREEN')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    round
                    :disabled="SaveButtonDisabled"
                    slot="activator"
                    color="secondary"
                    class="v-btn-5 dialogButton text-capitalize"
                    @click="saveEventDetails"
                  >{{$translate('SAVE')}}</v-btn>
                  <span>{{$translate('SAVE')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    round
                    slot="activator"
                    color="primary"
                    class="v-btn-5 dialogButton text-capitalize"
                    @click="closeComponent"
                  >{{$translate('DONE')}}</v-btn>
                  <span>{{$translate('CLOSE_EDIT_WINDOW')}}</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
    <v-dialog v-model="cancelEditDialog" persistent max-width="290">
      <v-card>
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{$translate('WARNING')}}</v-card-title>
        <v-card-text>{{$translate('UNSAVED_CHANGES')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="secondary"
            class="text-capitalize"
            @click="dontUndoChanges"
          >{{$translate('NO')}}</v-btn>
          <v-btn
            color="primary"
            round
            class="text-capitalize"
            @click="undoChanges"
          >{{$translate('YES')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import EventAudioLoader from '@/components/media/EventAudioLoader';
import * as dssRequest from '@/api/dssRequest';
import BaseObject from '@/objects/BaseObject';
import BaseComponent from '@/components/base/BaseComponent.vue';
import { ui_helpers } from '@/shared/ui_helpers';
import appConfig from '../../../config/app_config';

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: 'Events_Languages',
  props: {
    setEventName: {
      type: String,
      default() {
        return '';
      },
    },
    newEventId: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {
    EventAudioLoader,
  },
  data() {
    return {
      // Data read from the parent form that opens this form.
      EventName: '',
      EventId: 0,
      valid: true,
      LocationId: '',
      Main: false,
      MaxEventCapacity: 2,

      // Data read from the database.
      Languages: [],
      EventTranslations: {},

      // Data read from this form.
      EventSubtitle: '',
      Language: '',
      EventTranslationName: '',
      Description: '',
      ArrivalTextMessage: '',
      DepartureTextMessage: '',
      AudioArrivalUrl: '',
      AudioDepartureUrl: '',
      Question: '',
      CorrectAnswer: '',
      AnswerA: '',
      AnswerB: '',
      ConfirmationMailHeader: '',
      ConfirmationMailFooter: '',
      audioProp1: {
        title: 'Arrival audio message',
        signalName: 'selectAudio1Element',
        audioName: '',
        audioUrl: '',
      },
      audioProp2: {
        title: 'Departure audio message',
        signalName: 'selectAudio2Element',
        audioName: '',
        audioUrl: '',
      },

      // Static data in this form.
      LanguageSpec: 'Language specifics',

      // Variables.
      answerOptions: ['A', 'B'],
      Selected: -1,
      SaveButtonDisabled: true,
      cancelEditDialog: false,
      WantToGoBack: false,
      WantToClose: false,
    };
  },
  watch: {
    EventTranslationName: {
      handler(data2) {
        console.log("Lorenzo data2", data2);
      },
    },
    EventSubtitle: {
      handler(data) {
        console.log("Lorenzo data", data, this.EventTranslations);
      },
    },
  },
  beforeDestroy() {},
  methods: {
    toggle(ToggleIndex) {
      if (ToggleIndex != this.Selected) {
        if (!this.SaveButtonDisabled) {
          this.cancelEditDialog = true;
        } else {
          this.Selected = ToggleIndex;
          console.log('selected', this.Selected);
          this.Language = this.Languages[ToggleIndex].Language;
          if (
            this.EventTranslations[this.Languages[ToggleIndex].LanguageId]
            === undefined
          ) {
            this.EventTranslations[this.Languages[ToggleIndex].LanguageId] = {
              EventSubtitle: '',
              Description: '',
              EventTranslationName: '',
              ArrivalText: '',
              DepartureText: '',
              ArrivalAudio: '',
              DepartureAudio: '',
              Question: '',
              CorrectAnswer: '',
              AnswerA: '',
              AnswerB: '',
              ConfirmationMailHeader: '',
              ConfirmationMailFooter: '',
            };
          }
          console.log('toggleIndex', ToggleIndex);
          this.visualizeEventTranslations(ToggleIndex);
        }
      }
    },
    validateDescriptionField(value) {
      if (value.length === 0 && !this.SaveButtonDisabled) {
        return 'A description is required!';
      }
      return true;
    },
    disableSaveButtonDisabled() {
      console.log('disableSaveButtonDisabled called ?!?!?!');
      this.SaveButtonDisabled = false;
    },
    saveEventDetails() {
      if (this.$refs.eventLanguageForm.validate()) {
        const index = this.Languages[this.Selected].LanguageId;

        const payload = {
          EventId: this.EventId,
          [index]: {
            Subtitle: this.EventSubtitle,
            EventTranslationName: this.EventTranslationName,
            Description: this.Description,
            ArrivalText: this.ArrivalTextMessage,
            DepartureText: this.DepartureTextMessage,
            ArrivalAudio: this.AudioArrivalUrl,
            DepartureAudio: this.AudioDepartureUrl,
            Question: this.Question,
            CorrectAnswer: this.CorrectAnswer,
            AnswerA: this.AnswerA,
            AnswerB: this.AnswerB,
            ConfirmationMailHeader: this.ConfirmationMailHeader,
            ConfirmationMailFooter: this.ConfirmationMailFooter,
          },
          FunctionId: 'EventFunctionLibrary::saveEventTranslation',
        };
        this.EventTranslations[index] = {};
        this.EventTranslations[index].Subtitle = this.EventSubtitle;
        this.EventTranslations[index].EventTranslationName = this.EventTranslationName;
        this.EventTranslations[index].Description = this.Description;
        this.EventTranslations[index].ArrivalText = this.ArrivalTextMessage;
        this.EventTranslations[index].DepartureText = this.DepartureTextMessage;
        this.EventTranslations[index].ArrivalAudio = this.AudioArrivalUrl;
        this.EventTranslations[index].DepartureAudio = this.AudioDepartureUrl;
        this.EventTranslations[index].Question = this.Question;
        this.EventTranslations[index].CorrectAnswer = this.CorrectAnswer;
        this.EventTranslations[index].AnswerA = this.AnswerA;
        this.EventTranslations[index].AnswerB = this.AnswerB;
        this.EventTranslations[index].ConfirmationMailHeader = this.ConfirmationMailHeader;
        this.EventTranslations[index].ConfirmationMailFooter = this.ConfirmationMailFooter;

        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call saveEventTranslation was successful',
              response,
            );
          },
          (error) => {
            console.log(
              'The generic call saveEventTranslation was not successful',
              error,
            );
          },
          'communicateWithDBLibrary',
          appConfig.dss.eventAdminMng,
          payload,
        );

        this.SaveButtonDisabled = true;
      } else {
      }
    },
    undoChanges() {
      this.visualizeEventTranslations(this.Selected);
      this.SaveButtonDisabled = true;
      this.cancelEditDialog = false;
      this.$refs.eventLanguageForm.validate();
      if (this.WantToGoBack) {
        this.goBack();
      }
      if (this.WantToClose) {
        this.closeComponent();
      }
      this.WantToGoBack = false;
      this.WantToClose = false;
    },
    dontUndoChanges() {
      this.cancelEditDialog = false;
      this.WantToGoBack = false;
      this.WantToClose = false;
    },
    keymonitor(event) {
      //  if(event.key == "Enter")
      //  {
      //    return "///n";
      //  }
    },
    setAudioElement(d) {
      if (d.signalName !== undefined) {
        if (d.signalName === 'selectAudio1Element') {
          this.disableSaveButtonDisabled();
          this.audioProp1.audioUrl = d.url;
        } else if (d.signalName === 'selectAudio2Element') {
          this.disableSaveButtonDisabled();
          this.audioProp2.audioUrl = d.url;
        }
      }
    },
    formChanged() {
      this.SaveButtonDisabled = false;
    },
    goBack() {
      if (this.SaveButtonDisabled) {
        this.$emit('interface', this.EventId);
      } else {
        this.cancelEditDialog = true;
        this.WantToGoBack = true;
      }
    },
    closeComponent() {
      console.log(
        'closeComponent called, and this is the value of CloseEventLanguages: ',
        this.SaveButtonDisabled,
      );
      if (this.SaveButtonDisabled) {
        this.$emit('closeEventLanguages', {
          sideParam: { select: this.EventId },
        });
      } else {
        this.cancelEditDialog = true;
        this.WantToClose = true;
      }
    },
    visualizeEventTranslations(index) {
      console.log('index', index);
      let LanguageObject = {};

      if (index !== undefined) {
        LanguageObject = this.Languages[index];
      } else {
        // A for-of loop can be used with break. A forEach loop can not be used with break.
        for (const [i, e] of this.Languages.entries()) {
          console.log('I E ', i, e);
          if (this.EventTranslations[e.LanguageId] !== undefined) {
            LanguageObject = e;
            index = i;
            break;
          }
        }
      }

      if (index === undefined) {
        console.error(
          `[${
            this.$options.name
          }] Response on getEventTranslations() doesn't have data.`,
        );
        if (this.Languages.length > 0) {
          this.Selected = 0;
          this.Language = this.Languages[0].LocalName;
        }
        return;
      }

      if (this.EventTranslations[LanguageObject.LanguageId] === undefined) {
        this.EventSubtitle = '';
        this.Description = '';
        this.EventTranslationName = '';
        this.ArrivalTextMessage = '';
        this.DepartureTextMessage = '';
        this.audioProp1.audioUrl = '';
        this.audioProp2.audioUrl = '';
        this.Question = '';
        this.CorrectAnswer = '';
        this.AnswerA = '';
        this.AnswerB = '';
        this.ConfirmationMailHeader = '';
        this.ConfirmationMailHeader = '';
      } else {
        console.log("Lorenzo this.EventTranslations[LanguageObject.LanguageId]", this.EventTranslations[LanguageObject.LanguageId]);
        this.EventSubtitle = this.EventTranslations[
          LanguageObject.LanguageId
        ].Subtitle;
        this.EventTranslationName = this.EventTranslations[
          LanguageObject.LanguageId
        ].EventTranslationName;
        this.Description = this.EventTranslations[
          LanguageObject.LanguageId
        ].Description;
        this.ArrivalTextMessage = this.EventTranslations[
          LanguageObject.LanguageId
        ].ArrivalText;
        this.DepartureTextMessage = this.EventTranslations[
          LanguageObject.LanguageId
        ].DepartureText;
        this.AudioArrivalUrl = this.EventTranslations[
          LanguageObject.LanguageId
        ].ArrivalAudio;
        this.AudioDepartureUrl = this.EventTranslations[
          LanguageObject.LanguageId
        ].DepartureAudio;
        this.Question = this.EventTranslations[
          LanguageObject.LanguageId
        ].Question;
        this.CorrectAnswer = this.EventTranslations[
          LanguageObject.LanguageId
        ].CorrectAnswer;
        this.AnswerA = this.EventTranslations[
          LanguageObject.LanguageId
        ].AnswerA;
        this.AnswerB = this.EventTranslations[
          LanguageObject.LanguageId
        ].AnswerB;
        this.ConfirmationMailHeader = this.EventTranslations[
          LanguageObject.LanguageId
        ].ConfirmationMailHeader;
        this.ConfirmationMailFooter = this.EventTranslations[
          LanguageObject.LanguageId
        ].ConfirmationMailFooter;
      }
      this.Selected = index;
      this.Language = LanguageObject.LocalName;
    },

    // Get the event message translations from the database.
    getEventMessageTranslations() {
      // const payload = {
      //   FunctionId: 'dbAction',
      //   Action: 'SELECT',
      //   TableName: 'config.EventsTranslation',
      //   ReplyName: 'EventsTranslation',
      //   Columns: {
      //     Id: this.EventId,
      //   },
      // };

      const payload = {
        FunctionId: 'EventFunctionLibrary::getEventTranslations',
        EventId: this.EventId,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getEventTranslations was successful',
            response,
          );
          if (!response.hasOwnProperty('data')) {
            console.error(
              `[${
                this.$options.name
              }] Response on getEventTranslations() doesn't have data. EventId=`,
              this.newEventId,
            );
            return;
          }
          if (response.data.EventsTranslation.celldata.length > 0) {
            const data = BaseObject._createArrayWithObjects(response.data.EventsTranslation);
            console.log('Recieved eventTranslation data: ', data);
            const translationData = [];
            // Storing the recieved EventId
            this.EventTranslations.EventId = Number(data[0].EventId);
            // Creating the data for a event translation and deleting the EventId from the data
            for (let i = 0; i < data.length; i++) {
              translationData.push(data[i].LanguageTagId);
              delete data[i].EventId;
            }
            for (const key of translationData) {
              this.EventTranslations[key] = {};
              for (let i = 0; i < data.length; i++) {
                if (key == data[i].LanguageTagId) {
                  this.EventTranslations[key] = data[i];
                }
              }
            }
            this.visualizeEventTranslations();
          } else {
            this.visualizeEventTranslations();
          }
        },
        (error) => {
          console.log(
            'The generic call getEventTranslations was not successful',
            error,
          );
        },
        'communicateWithDBLibrary',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },

    // Get all language tags from the database.
    getAllLanguageTags() {
      // This used to be the generic call getAllLanguageTags
      const payload = {
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getAllLanguageTags was successful',
            response,
          );
          if (!response.hasOwnProperty('data')) {
            console.error(
              `[${
                this.$options.name
              }] Response on getAllLanguageTags() doesn't have data.`,
            );
            return;
          }

          if (!response.data.hasOwnProperty('Languages')) {
            console.error(
              `[${
                this.$options.name
              }] Response on getAllLanguageTags() doesn't have Languages.`,
            );
            return;
          }

          this.Languages = [];
          this.Languages = [...response.data.Languages];

          this.getEventMessageTranslations();
        },
        (error) => {
          console.log(
            'The generic call getAllLanguageTags was not successful',
            error,
          );
        },
        'getAllLanguageTags',
        this.$store.getters.getCurrentAccountId,
        payload,
      );
    },
  },
  created() {
    console.log('newEVENTID', this.newEventId);
    this.EventName = this.setEventName;
    this.EventId = Number(this.newEventId);

    if (isNaN(this.EventId)) {
      console.error(
        `[${
          this.$options.name
        }] EventId from parent is NOT a number. EventId=`,
        this.newEventId,
      );
      return;
    }

    this.getAllLanguageTags();
  },
};
</script>

<style>
.outliningRightSide {
  margin-top: 10.8em !important;
}

.eventAnswerBOutlining {
 margin-top: 2.25em;
}

.scrollablePage {
  height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.flexStyle {
  margin-top: 2pt;
  margin-left: 2pt;
  margin-bottom: 2pt;
  margin-right: 2pt;
  background-color: lightblue;
  height: 60px;
}
</style>
